import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { imgTema6 } from '../../../assets/tema6';
import { QuestionCardV3 } from '../../../components/common/QuestionCardV3';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	questions: 3,
	win: 4,
	fail: 5,
};

const stepThree = {

}

const gameQuestion = [
	{
		id: 1,
		question: "¿A cuánto equivale 1 punto Spin Premia?",
		img: imgTema6.QuestionCard7,
		options: [
			{
				id: 1,
				text: "$0.15 pesos",
			},
			{
				id: 2,
				text: "$0.10 pesos",
				isCorrect: true
			},
			{
				id: 3,
				text: "$1.00 pesos",
			},
		]
	},
	{
		id: 2,
		question: "El ticket al pagar con Spin Premia, nos mostrará la cantidad de puntos, el pago y el nuevo saldo.",
		img: imgTema6.QuestionCard5,
		options: [
			{
				id: 1,
				text: "Verdadero",
				isCorrect: true,
			},
			{
				id: 2,
				text: "Falso",
			},
		]
	},
]
let pointsAcumulated = 0


export const Theme6SubtopicFiveActivityFour = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema6.activities.subtema5], 4);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 6 sub 4 act 4");
			ObserverEmitter.emit(EVENTS.tema6.topic5.initScene, 4);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub05.sub5_act4_a01)
	})

	ObserverEmitter.on(EVENTS.tema6.topic5.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	const [selectQuestionGame, setSelectQuestionGame] = useState({
		question: "",
		img: "",
		options: [
			{
				id: 1,
				text: ""
			},
			{
				id: 2,
				text: ""
			},
			{
				id: 3,
				text: ""
			},
		]
	})
	const [numberQuestion, setNumberQuestion] = useState(0)
	const [saveResponse, setSaveResponse] = useState(0)

	const actionGameQuestion = (statusCorrect = 0) => {
		const updatedResponse = statusCorrect === 1 ? saveResponse + 1 : saveResponse;
		setSaveResponse(updatedResponse);

		// console.log(updatedResponse);
		pointsAcumulated = updatedResponse * 10

		if (numberQuestion >= gameQuestion.length - 1) {
			ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "expand_desk");
			if (updatedResponse >= 1) {
				setUiToShow(steps.win);
			} else {
				setUiToShow(steps.fail);
			}
			return;
		}
		setNumberQuestion(numberQuestion + 1);
	};

	const setDataQuestion = () => {
		const selectData = gameQuestion[numberQuestion]
		setSelectQuestionGame(selectData)
	}

	useEffect(() => {
		setDataQuestion()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [numberQuestion])

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 3].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema6.topic5.initScene, 4);
						setNumberQuestion(0)
						setSaveResponse(0)
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Ejercicio: Preguntas." />
					<DialogBarNew
						dialog={`¡Lo has hecho muy bien! Es momento de medir el conocimiento adquirido dentro de nuestro curso.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 5. Spin by OXXO"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "client");
							setUiToShow(steps.questions);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.questions && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies activities={tasksList} />
					<QuestionCardV3 data={selectQuestionGame} actionGameQuestion={actionGameQuestion} />
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={pointsAcumulated}
						dialogModal="Recuerda que un buen servicio al atender a nuestros Clientes, te ayudará a qué regresen a la Tienda."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 4,
									pointsWin: pointsAcumulated,
									subtema: tasksId.tema6.activities.subtema5
								})
							);
							navigator("/home6/tema6/subtema5/activityresult");
						}}
					/>
				</>
			)}
			{uiToShow === steps.fail && (
				<>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={pointsAcumulated}
						dialogModal="¡Tú puedes! Cada tema te ayudará a comprender los pasos de cada servicio; repasa donde tengas dificultad."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 4,
									pointsWin: pointsAcumulated,
									subtema: tasksId.tema6.activities.subtema5
								})
							);
							navigator("/home6/tema6/subtema5/activityresult");
						}}
					/>
				</>
			)}
		</>
	)
}